export const LOADING = '_LOADING';
export const LOADED = '_LOADED';
export const ERROR = '_ERROR';

export const BASIC_STATE = {
  data: {},
  error: null,
  loader: false,
};
